import { CompanyProductUserMemberRoleEnum } from '../enums/company-product-user-member-role.enum';
import { CompanyProductUserMember } from '../models/company_product_user_member.model';
import { UserListDialogBadge } from '../models/user-list-dialog.model';

const PRODUCT_TRIO_SLUGS = new Set<string>([
  CompanyProductUserMemberRoleEnum.PRODUCT_MANAGER,
  CompanyProductUserMemberRoleEnum.TECH_LEAD,
  CompanyProductUserMemberRoleEnum.PRODUCT_DESIGNER,
]);

export function buildCompanyProductMemberRoleBadges(member: CompanyProductUserMember | null | undefined): UserListDialogBadge[] {
  const role = member?.company_product_user_member_role;
  if (role == null) {
    return [];
  }

  const badges: UserListDialogBadge[] = [
    {
      label: role.name,
      kind: 'role',
      slug: role.slug,
    },
  ];

  if (PRODUCT_TRIO_SLUGS.has(role.slug)) {
    badges.push({
      label: 'Product trio',
      kind: 'product-trio',
    });
  }

  return badges;
}

export function indexCompanyProductMembersByUserId(members: CompanyProductUserMember[]): Map<number, CompanyProductUserMember> {
  return new Map(members.map(member => [member.user_id, member]));
}
